var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"activity-image-buttons"},_vm._l((_vm.randomisedData),function(image){return _c('ActivityImageButton',{key:image.id,style:({
      width: `${_vm.size}px`,
      height: `${_vm.size}px`,
    }),attrs:{"src":_vm.isOnline ? image.value : _vm.findPreloadedAsset('image', image.value),"bg-color":_vm.selectedButtons.includes(image.id) ? '#87c040' : 'transparent'},nativeOn:{"click":function($event){return _vm.handleClick(image)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }